import axios from "axios";

export const caxios = axios.create({
  baseURL: `https://tntadmin-1030833709933.asia-northeast3.run.app`
});


caxios.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});
